export default __webpack_public_path__ + "static/media/student-read.9bece92d.png";